// Libs
import styled from "styled-components";
import { theme } from "Globals/Styles/AppTheme";
import React, { useState } from "react";
import { useObserver, useRouter } from "@shoothill/core";
import { Box, CircularProgress, Button, Typography } from "@material-ui/core";

// App

export interface IProps {
    text: string;
    loading?: boolean;
    disabled?: boolean;
    onClick?: () => any;
}

export const LoadingButtonStyles = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${theme.palette.hightownBlue.light};
    border: 3px solid transparent;
    background-color: ${theme.palette.common.white};
    border-radius: 5px;
    padding: 7px 30px;

    @media (max-width: 768px) {
        height: 48px;
        padding: 0px 30px;
        width: 100%;
        > span {
            font-size: 16px !important;
        }
    }

    > span {
        white-space: nowrap;
        font-size: 12px;
    }

    &:hover {
        color: ${theme.palette.hightownBlue.light};
        border: 3px solid ${theme.palette.hightownBlue.light};
        background-color: transparent;
        box-shadow: none;
    }
`;

export const LoadingButton: React.FC<IProps> = (props: IProps) => {
    return useObserver(() => (
        <>
            <LoadingButtonStyles variant="contained" disabled={props.disabled} onClick={props.onClick}>
                {props.loading ? (
                    <>
                        Loading
                        <CircularProgress size={20} />
                    </>
                ) : (
                    <>{props.text}</>
                )}
            </LoadingButtonStyles>
        </>
    ));
};
